(() => {
  const e = document.querySelector(".ajax__cart"),
    t = document.querySelector(".ajax__cart-close"),
    o = document.querySelector("[data-cart-trigger]"),
    c = document.querySelector(".block__placeholder");
  function n() {
    const e = document.querySelector(".ajax__cart-title"),
      t = document.querySelector(".ajax__cart-footer");
    document.querySelector(
      ".ajax__cart-content"
    ).style.height = `calc(100vh - ${
      e.offsetHeight + 32 + t.offsetHeight + (window.innerWidth <= 767 ? 80 : 0)
    }px)`;
  }
  function r() {
    e.classList.remove("is-open"),
      c.classList.remove("is-show"),
      document.body.classList.remove("overflow");
  }
  window.addEventListener("load", n),
    window.addEventListener("resize", n),
    t.addEventListener("click", r),
    o.addEventListener("click", function () {
      e.classList.add("is-open"),
        c.classList.add("is-show"),
        document.body.classList.add("overflow");
    }),
    c.addEventListener("click", r);
})();
